import Services from "../../../services";

class JenisApi {
  getPage(page, dataLength, key) {
    return Services.get(`/jenis/page/?page=${page}&per_page=${dataLength}&q=${key}`);
  }
  getDataKelompok() {
    return Services.get("/jenis/kelompok?id_buaso=1&flag=BH");
  }
  create(data) {
    return Services.post("/jenis", data);
  }
  update(data) {
    return Services.put("/jenis", data);
  }
  delete(id_jenis) {
    return Services.post("/jenis/delete", id_jenis);
  }
  search(key) {
    return Services.get(`jenis/page/?q=${key}`);
  }
  show(id_jenis) {
    return Services.post("/jenis/show", id_jenis);
  }
  hide(id_jenis) {
    return Services.post("/jenis/hide", id_jenis);
  }
  checkDuplicateNama(params) {
    return Services.get('/jenis/check_duplicate/', { params })
  }
}

export default new JenisApi();
